const ElementGroups = {
	block: "block",
	inline: "inline",
	listItem: "listItem",
	listItemContent: "listItemContent",
	list: "list",
	tab: "tab",
};

export default ElementGroups;
